import { localeState, translate } from "../i18n"
import { platformMediaUrl } from "./media"

const JSON_LD_ID = "starlive-structured-data"
const SOCIAL_IMAGE_PATH = platformMediaUrl("covers/city-night.webp")

function absoluteUrl(path = "/") {
  return new URL(path, window.location.origin).href
}

function upsertMeta(selector, attributes) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement("meta")
    document.head.appendChild(element)
  }
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value))
}

function upsertLink(rel, href) {
  let element = document.head.querySelector(`link[rel="${rel}"]`)
  if (!element) {
    element = document.createElement("link")
    element.rel = rel
    document.head.appendChild(element)
  }
  element.href = href
}

function localizedOgLocale() {
  return localeState.language.replace("-", "_")
}

function writeStructuredData(pageTitle, description, canonicalUrl) {
  let element = document.getElementById(JSON_LD_ID)
  if (!element) {
    element = document.createElement("script")
    element.id = JSON_LD_ID
    element.type = "application/ld+json"
    document.head.appendChild(element)
  }

  // 只声明平台能够稳定证明的实体，不虚构社交账号、评分或搜索接口。
  element.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${window.location.origin}/#organization`,
        name: "StarLive",
        url: `${window.location.origin}/`,
        logo: absoluteUrl("/favicon.svg")
      },
      {
        "@type": "WebSite",
        "@id": `${window.location.origin}/#website`,
        url: `${window.location.origin}/`,
        name: "StarLive",
        alternateName: ["Star Live"],
        description,
        inLanguage: localeState.language,
        publisher: { "@id": `${window.location.origin}/#organization` }
      },
      {
        "@type": "WebPage",
        "@id": `${canonicalUrl}#webpage`,
        url: canonicalUrl,
        name: pageTitle,
        description,
        inLanguage: localeState.language,
        isPartOf: { "@id": `${window.location.origin}/#website` }
      }
    ]
  })
}

export function updateSeo(page = "home") {
  const pageKey = ["home", "discover", "message", "profile"].includes(page) ? page : "home"
  const pageName = translate(`seo.pages.${pageKey}`)
  const description = translate(`seo.descriptions.${pageKey}`)
  const title = pageKey === "home" ? translate("seo.title") : `${pageName} | StarLive`
  const canonicalUrl = absoluteUrl(window.location.pathname || "/")
  const socialImage = absoluteUrl(SOCIAL_IMAGE_PATH)

  document.title = title
  upsertMeta('meta[name="description"]', { name: "description", content: description })
  upsertMeta('meta[name="robots"]', { name: "robots", content: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1" })
  upsertMeta('meta[property="og:type"]', { property: "og:type", content: "website" })
  upsertMeta('meta[property="og:site_name"]', { property: "og:site_name", content: "StarLive" })
  upsertMeta('meta[property="og:title"]', { property: "og:title", content: title })
  upsertMeta('meta[property="og:description"]', { property: "og:description", content: description })
  upsertMeta('meta[property="og:url"]', { property: "og:url", content: canonicalUrl })
  upsertMeta('meta[property="og:image"]', { property: "og:image", content: socialImage })
  upsertMeta('meta[property="og:locale"]', { property: "og:locale", content: localizedOgLocale() })
  upsertMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" })
  upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title })
  upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description })
  upsertMeta('meta[name="twitter:image"]', { name: "twitter:image", content: socialImage })
  upsertLink("canonical", canonicalUrl)
  writeStructuredData(title, description, canonicalUrl)
}
